export default class EDILABOFileDto {
    constructor(obj) {
        this.label = obj.name
        this.href = obj.path
        this.updateDate = obj.updateDate
    }
}